import { render, staticRenderFns } from "./zt.vue?vue&type=template&id=a965dfae&scoped=true"
import script from "./zt.vue?vue&type=script&lang=js"
export * from "./zt.vue?vue&type=script&lang=js"
import style0 from "./zt.vue?vue&type=style&index=0&id=a965dfae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a965dfae",
  null
  
)

export default component.exports